import { render, staticRenderFns } from "./distributionWrapper.vue?vue&type=template&id=e573af02&scoped=true"
import script from "./distributionWrapper.vue?vue&type=script&lang=js"
export * from "./distributionWrapper.vue?vue&type=script&lang=js"
import style0 from "./distributionWrapper.vue?vue&type=style&index=0&id=e573af02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e573af02",
  null
  
)

export default component.exports